import * as React from 'react';
import { Modal } from '../internal/Modal';
import { classes, st } from './CustomDialog.st.css';
import { CustomDialogProps, CustomDialogState } from './types';

/** CustomDialog */
export const CustomDialog: React.FC<CustomDialogProps & CustomDialogState> = ({
  className,
  children,
  isOpen = false,
  onClose,
  manualFocus = false,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'data-hook': dataHook,
  appendToBody = false,
}) => {
  return (
    <Modal
      className={st(classes.root, className)}
      data-hook={dataHook}
      isOpen={isOpen}
      focusTrap={!manualFocus}
      onRequestClose={onClose}
      appendToBody={appendToBody}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
      >
        {children}
      </div>
    </Modal>
  );
};

CustomDialog.displayName = 'CustomDialog';
